import { CommandMenuItems } from '@/shared/commands/CommandMenuItems'

import type { Column } from '~shared/rundown/column'

import { useGridSnap } from '../grid/grid.store'

import { columnMenuGroups, useColumnCommandContext } from './column.commands'

export function ColumnContextMenu() {
  const { contextMenu } = useGridSnap()

  if (!contextMenu || contextMenu.type !== 'column') return null

  return <ColumnContextMenuItems columnId={contextMenu.columnId} />
}

function ColumnContextMenuItems({ columnId }: { columnId: Column['id'] }) {
  const context = useColumnCommandContext(columnId)
  if (!context) return null

  return (
    <CommandMenuItems
      groups={columnMenuGroups}
      context={context}
    />
  )
}
